/**
 * @file copy from https://github.com/jsmini/type/blob/0.11.0/src/index.js
 *
 * 为什么不直接使用 pnpm 包?
 * 因为 @jsmini/clone 依赖的 @jsmini/type 设置了 only-allow npm，而我们使用了 pnpm 会导致安装失败
 * https://github.com/jsmini/type/blob/2e10c93c65c77d37fe1941d8577c1504a775be9e/package.json#L29
 *
 * TODO: 替换成其它库实现
 */

const { toString } = Object.prototype;

export function type(x, s = false) {
  let strict = s;
  strict = !!strict;

  // fix typeof null = object
  if (x === null) {
    return 'null';
  }

  const t = typeof x;

  // 严格模式 区分NaN和number
  if (strict && t === 'number' && isNaN(x)) {
    return 'nan';
  }

  // number string boolean undefined symbol
  if (t !== 'object') {
    return t;
  }

  let cls;
  let clsLow;
  try {
    cls = toString.call(x).slice(8, -1);
    clsLow = cls.toLowerCase();
  } catch (e) {
    // ie下的 activeX对象
    return 'object';
  }

  if (clsLow !== 'object') {
    if (strict) {
      // 区分NaN和new Number
      if (clsLow === 'number' && isNaN(x)) {
        return 'NaN';
      }
      // 区分 String() 和 new String()
      if (clsLow === 'number' || clsLow === 'boolean' || clsLow === 'string') {
        return cls;
      }
    }
    return clsLow;
  }

  // eslint-disable-next-line eqeqeq
  if (x.constructor == Object) {
    return clsLow;
  }

  // Object.create(null)
  try {
    // __proto__ 部分早期firefox浏览器
    if (Object.getPrototypeOf(x) === null || x.__proto__ === null) {
      return 'object';
    }
  } catch (e) {
    // ie下无Object.getPrototypeOf会报错
  }

  // function A() {}; new A
  try {
    const cname = x.constructor.name;

    if (typeof cname === 'string') {
      return cname;
    }
  } catch (e) {
    // 无constructor
  }

  // function A() {}; A.prototype.constructor = null; new A
  return 'unknown';
}
